import PropTypes from 'prop-types';

import styles from './MobileSignSettingContent.module.scss';

/**
 * 모바일 서명설정 콘텐츠 컴포넌트
 * - Figma 디자인 기반: 서명 표시 및 변경 기능
 */
export default function MobileSignSettingContent({ signImageUrl, isLoading, onRegister }) {
  return (
    <div className={styles.container}>
      {/* 서명 변경 섹션 */}
      <div className={styles.signSection}>
        <div className={styles.sectionHeader}>
          <span className={styles.sectionTitle}>현재 등록된 서명</span>
          <button type="button" className={styles.fileRegisterButton} onClick={onRegister}>
            <span className={styles.fileRegisterText}>서명 변경</span>
          </button>
        </div>

        {/* 서명 표시 영역 */}
        <div className={styles.signDisplayArea}>
          {isLoading ? (
            <div className={styles.loadingText}>로딩 중...</div>
          ) : signImageUrl ? (
            <img src={signImageUrl} alt="현재 서명" className={styles.signImage} />
          ) : (
            <div className={styles.emptyText}>등록된 서명이 없습니다.</div>
          )}
        </div>
      </div>
    </div>
  );
}

MobileSignSettingContent.propTypes = {
  signImageUrl: PropTypes.string,
  isLoading: PropTypes.bool,
  onRegister: PropTypes.func.isRequired,
};

MobileSignSettingContent.defaultProps = {
  signImageUrl: null,
  isLoading: false,
};
